import { ArrowLeftOutlined, HomeOutlined } from '@ant-design/icons';
import { Button, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LinkFullWidth } from '../../../styles/ui';


const BackButton = ({
  onBack,
  showHome,
  fullWidth = false,
}:{
  onBack: () =>  void;
  showHome: boolean;
  fullWidth?: boolean | undefined;
}) => {
  const { t } = useTranslation();
  if (showHome){
    return (
      <LinkFullWidth
        to={{ pathname:  '/' }}
      >
        <Button
          icon={<HomeOutlined />}
        >
          {t('GoBack')}
        </Button>
      </LinkFullWidth>
    );
  }
  return (
    <Button
      type="default"
      onClick={onBack}
      style={fullWidth ? { width: '100%' } : {}}
    >
      <Row align="middle" justify="center">
        <ArrowLeftOutlined style={{ marginRight: 6 }} />
        {t('GoBack')}
      </Row>
    </Button>
  );
};

export default BackButton;

